<template>
  <v-card
    v-if="!this.consigneeAddress"
    :class="[
      'post-code-input',
      'pt-10',
      'pt-md-0',
      $rttI18n.isGlsItSelected ? 'post-code-input-bordered' : ''
    ]"
    variant="flat"
  >
    <div class="post-code-input-form v-col-12">
      <p v-if="this.isServiceTypePickup" class="desc">
        {{ $t('pickupAddress.description') }}
      </p>
      <p v-else class="desc">{{ $t('deliveryAddress.description') }}</p>
      <v-form
        :ref="postcodeForm"
        v-model="valid"
        v-on:submit.prevent="wrapperLoadAdditionalTrackingData"
      >
        <v-text-field
          v-model="postcode"
          :label="$t('generic.postcode')"
          :rules="postcodeRules"
          :type="
            configGetter($rttI18n.tenantId, themeId).postCodeTextInput
              ? 'text'
              : 'tel'
          "
          bg-color="#fff"
          color="anchor"
          density="compact"
          required
          variant="outlined"
        ></v-text-field>
        <GDPRConsentComponent
          v-if="
            !configGetter(this.$rttI18n.tenantId, this.themeId).gdprApproved
          "
        ></GDPRConsentComponent>
        <div>
          <v-btn
            :block="true"
            :disabled="!isSubmitEnabled"
            color="anchor"
            type="submit"
            variant="flat"
            v-on:click.prevent="wrapperLoadAdditionalTrackingData"
            >{{ $t('deliveryAddress.buttonLabel') }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import GDPRConsentComponent from '@/components/GDPRConsentComponent';
import { configGetter } from '@/config/configGetter';
import { getUtmSource } from '@/router/queryParam.js';
import { useGdprStore } from '@/stores/gdpr.js';
import { useThemeStore } from '@/stores/theme.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useWebsocketStore } from '@/stores/websocket.js';
import { sendAnalytics } from '@/services/analytics.js';

export default {
  name: 'PostCodeInputComponent',
  components: {
    GDPRConsentComponent
  },
  data() {
    return {
      postcode: null,
      postcodeForm: null,
      postcodeRules: [v => !!v || this.$t('inputs.rules.postcode')],
      valid: false,
      configGetter
    };
  },
  computed: {
    ...mapState(useGdprStore, ['hasGdprConsent']),
    ...mapState(useThemeStore, ['themeId']),
    ...mapState(useTrackingDataStore, {
      myTrackingData: 'data',
      isServiceTypePickup: 'isServiceTypePickup',
      consigneeAddress: 'consigneeAddress'
    }),
    isSubmitEnabled() {
      return (
        (this.configGetter(this.$rttI18n.tenantId, this.themeId).gdprApproved ||
          this.hasGdprConsent(this.$rttI18n.tenantId)) &&
        this.valid
      );
    }
  },
  methods: {
    ...mapActions(useTrackingDataStore, ['loadAdditionalTrackingData']),
    ...mapActions(useWebsocketStore, ['unSubscribeToUpdates']),
    async wrapperLoadAdditionalTrackingData() {
      const payload = {
        utmSource: getUtmSource(this.$route),
        tenantId: this.$rttI18n.tenantId,
        postcode: this.postcode,
        trackingId: this.myTrackingData.trackingId
      };
      this.unSubscribeToUpdates();
      await this.loadAdditionalTrackingData(payload);

      sendAnalytics(
        this.myTrackingData,
        'clickStats',
        `postcode_track_button_clicked`
      );
    }
  },
  mounted() {
    const trackingDataStore = useTrackingDataStore();
    trackingDataStore.$subscribe((mutation, state) => {
      if (!trackingDataStore.consigneeAddress) {
        this.postcode = null;
      }
    });
  }
};
</script>

<style scoped>
/* the component is displayed above other components */
.post-code-input {
  background-color: rgba(255, 255, 255, 0.75);
  position: absolute;
  width: 100%;
  z-index: 2;
  min-height: 100%;
  border: 1px solid #e3e2e3;
}

.post-code-input-bordered {
  background-color: rgba(255, 255, 255, 1);

  border: 1px solid #e6e8f7;

  transition: All 0.2s ease;
  -webkit-transition: All 0.2s ease;
}

.post-code-input-bordered:hover {
  border-bottom: 3px solid #061ab1;
}

.post-code-input-form {
  background-color: transparent;
  border: unset;
}

.desc {
  font-weight: 500;
  text-align: center;
}
</style>
